// @flow
import React, { useState, useRef } from 'react'
import InputStore from '~/stores/forms/builder/input_store'
import { executeRecaptcha } from '~/util/recaptcha'

const RECAPTCHA_ERROR_MESSAGE = 'reCAPTCHA認証に失敗しました。もう一度やり直してください'

type Props = {
  action: string,
  method: string,
  inputStores: Array<InputStore<any, any>>,
  closeModal: () => void,
  onSubmit: () => void,
  recaptchaSiteKey?: string
}

const FormModalPreview = ({action, method, inputStores, closeModal, onSubmit, recaptchaSiteKey}: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const formRef = useRef(null)
  
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (isSubmitting) return

    setIsSubmitting(true)
    const form = formRef.current
    if (!form){
      setIsSubmitting(false)
      return
    }
    
    try {
      const formData = new FormData(form)
      if (recaptchaSiteKey) {
        const token = await executeRecaptcha(recaptchaSiteKey, 'submit_store_application')
        formData.append('recaptcha_token', token)
      }
      const response = await fetch(form.action, {
        method: form.method,
        body: formData,
      })
      if (response.ok) {
        onSubmit()
        window.location.href = response.url
      } else {
        const contentType = response.headers.get('content-type') || ''
        if (contentType.includes('application/json')) {
          const errorData = await response.json()
          alert(errorData.message || RECAPTCHA_ERROR_MESSAGE)
        } else {
          const errText = await response.text()
          alert(errText || RECAPTCHA_ERROR_MESSAGE)
        }
        setIsSubmitting(false)
      }
    } catch (error) {
      console.error('reCAPTCHA failed:', error)
      alert(RECAPTCHA_ERROR_MESSAGE)
      setIsSubmitting(false)
    }
  }
  
  return (
    <form ref={formRef} action={action} method={method} onSubmit={handleSubmit} className="formsFormWithModalPreview-Preview">
      {
        inputStores.map((inputStore, index) => (
          <input type="hidden" name={inputStore.getName()} value={inputStore.getValue()} key={index} />
        ))
      }

      <div className="formsFormWithModalPreview-Preview_Container">
        <div className="formsFormWithModalPreview-Preview_Title">以下の内容で送信してよろしいですか？</div>
        {
          inputStores
            .filter((inputStore) => inputStore.type !== "hidden")
            .map((inputStore, index) => (
              <div className="formsFormWithModalPreview-Preview_Input" key={index}>
                <div className="formsFormWithModalPreview-Preview_Label">
                  {inputStore.label}
                </div>
                <div className="formsFormWithModalPreview-Preview_Value">
                  {inputStore.getValueText()}
                </div>
              </div>
            ))
        }
      </div>
      <div className="formsFormWithModalPreview-Preview_Buttons">
        <button type="button" className="formsFormWithModalPreview-Preview_CloseBtn" onClick={closeModal}>
          もどる
        </button>
        <input 
          type="submit" 
          value={isSubmitting ? '送信中...' : '送信する'} 
          className="formsFormWithModalPreview-Preview_SubmitBtn"
          disabled={isSubmitting}
        />
      </div>
    </form>
  )
}

export default FormModalPreview
